export const MODAL_OVERLAY_PROPS = {
	bg: "blackAlpha.300",
	backdropFilter: "blur(10px)",
};

export const MODAL_CONTENT_PROPS = {
	borderRadius: "xl",
	boxShadow: "2xl",
	maxH: "85vh",
};

export const MODAL_BODY_PROPS = {
	py: 4,
	px: 6,
	overflowY: "auto",
};

export const MODAL_FOOTER_PROPS = {
	pt: 3,
	pb: 4,
	px: 6,
};

export const MODAL_GRID_SPACING = 4;
export const MODAL_SECTION_SPACING = 4;
